const styles = (theme) => ({
  root: {
    display: 'block',
    padding: theme.spacing(2),
  },
  cardHolder: {
    margin: theme.spacing(2, 0),
    borderRadius: `${theme.spacing(1)}px !important`,
    boxShadow: '0px 4px 4px 0px rgb(0 0 0 / 5%), 0px 1px 1px 0px rgb(0 0 0 / 15%)',
    '&::before': {
      height: 0,
    },
    '&.MuiAccordion-root.Mui-expanded': {
      boxShadow: 'none',
    },
    // When auto-scrolling, margin from top of the viewport
    scrollMargin: `${theme.spacing(1)}px`,
  },
  counter: {
    background: theme.color.teal,
    color: theme.color.white,
    width: 25,
    height: 25,
    lineHeight: '25px',
    textAlign: 'center',
    borderRadius: 16,
    marginRight: theme.spacing(1),
  },
  summary: {
    '& > div': {
      alignItems: 'center',
    },
  },
  summaryExpanded: {
    '& .MuiAccordionSummary-content.Mui-expanded': {
      margin: theme.spacing(1.5, 0),
    },
  },
  secondHeaderHolder: {
    background: theme.color.grey_mist,
    borderBottom: `1px solid ${theme.color.teal}`,
    '& > .MuiAccordionSummary-content': {
      margin: theme.spacing(1),
    },
  },
  secondHeader: {
    width: '100%',
  },
  moreButton: {
    marginLeft: 'auto',
  },
});

export default styles;
